import { z } from 'zod';
import { USER_TEAM } from '../../../../../constants';

export const deskManagementFormSchema = z.object({
    bookingTeams: z.array(z.nativeEnum(USER_TEAM)).optional().nullable(),
    outOfService: z.boolean().optional(),
});

export type DeskManagementFormSchema = z.infer<typeof deskManagementFormSchema>;
